"use client";

import createSvgIcon from "./utils/createSvgIcon.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "M4 10h18V6c0-1.1-.9-2-2-2h-3l2 4h-3l-2-4h-2l2 4h-3L9 4H7l2 4H6L4 4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h8v-2H4zm10 8.88V21h2.12l5.17-5.17-2.12-2.12zM22.71 13l-.71-.71a.996.996 0 0 0-1.41 0l-.71.71L22 15.12l.71-.71c.39-.39.39-1.02 0-1.41"
}), 'MovieEdit');